import { z } from 'zod';
export const UuidSchema = z.string().uuid();
export const HealthResponseSchema = z.object({
    service: z.string(),
    status: z.literal('ok'),
    correlation_id: z.string(),
    timestamp: z.string().datetime(),
});
export const StoreCodeSchema = z
    .string()
    .min(2)
    .max(8)
    .regex(/^[A-Z0-9-]+$/);
//# sourceMappingURL=common.js.map